// extracted by mini-css-extract-plugin
module.exports = {"video-demo":"rlaW+5hdL0rNW+t3YP2mYw==","os-screenshots":"V3DP0lOxjMvDuMu9IKZDnw=="};